import store from '@/store'

var permission = (el, binding, vnode) => {
  const { value } = binding
  const roles = store.getters && store.getters.roles
  const userType = []

  value.map(ele => {
    const type = ele.split('-')[0]
    if (userType.indexOf(type) === -1) {
      userType.push(type)
    }
  })
  userType.map(ele => {
    value.push(`${ele}-0`)
  })

  if (value && value instanceof Array && value.length > 0) {
    const permissionRoles = value

    const hasPermission = roles.some(role => {
      return permissionRoles.includes(role)
    })

    if (!hasPermission) {
      el.style.display = 'none'
      // console.log('无权限')
      // el.parentNode && el.parentNode.removeChild(el)
    } else {
      // console.log('有权限')
      el.style.display = ''
      // vnode.context.$parent.$el.appendChild(el)
    }
  } else {
    throw new Error(`need roles! Like v-permission="['admin','editor']"`)
  }
}

// const timer = null

export default {
  inserted(el, binding, vnode) {
    permission(el, binding, vnode)
  },
  update(el, binding, vnode) {
  // if (timer != null) {
  //   clearTimeout(timer)
  // }
  // timer = setTimeout(() => {
  //   console.log('执行')
    permission(el, binding, vnode)
  // }, 100)
  }
}
